const BookingSummaryMixin = {
	computed: {
		isMultipleServiceBookingEnabled() {
            return this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED;
        },
        paidInServiceType() {
            return this.isMultipleServiceBookingEnabled ?
                this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.some(product => product.isPaid)
                : ((this.$store.getters.GET_BOOKING_STATE.selectedService && this.$store.getters.GET_BOOKING_STATE.selectedService.is_paid === 2) || false);
        },
        isPaidOverall() {
            return this.paidInServiceType;
        },
        showComputations() {
            return this.isPaidOverall;
        },
        showItems() {
            return this.isPaidOverall;
        },
        hasProductItemsAlready() {
            return this.isMultipleServiceBookingEnabled && this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.length > 0;
        }
	}
};

module.exports = BookingSummaryMixin;